import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";

interface State {
  tokenLoaded: boolean;
  accessChecked: boolean;
  tokenRestored: boolean;
}

const initialState: State = {
  tokenLoaded: false,
  accessChecked: false,
  tokenRestored: false,
};

export const overlaySlice = createSlice({
  name: "overlay",
  initialState,
  reducers: {
    finishedLoadingToken: (state) => {
      state.tokenLoaded = true;
    },
    resetAccessCheck: (state) => {
      state.accessChecked = false;
    },
    finishedAccessCheck: (state) => {
      state.accessChecked = true;
    },
    setTokenRestored: (state, action: PayloadAction<boolean>) => {
      state.tokenRestored = action.payload;
    },
    resetTokenRestored: (state) => {
      state.tokenRestored = false;
    },
    resetTokenLoaded: (state) => {
      state.tokenLoaded = false;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  finishedLoadingToken,
  finishedAccessCheck,
  resetAccessCheck,
  setTokenRestored,
  resetTokenRestored,
  resetTokenLoaded,
} = overlaySlice.actions;

// Selector to determine if the overlay should be shown
export const selectShouldShowOverlay = createSelector(
  (state: { overlay: State }) => state.overlay.tokenLoaded,
  (state: { overlay: State }) => state.overlay.accessChecked,
  (tokenLoaded, accessChecked) => !tokenLoaded || !accessChecked,
);

export const selectCompleteInitialChecks = createSelector(
  (state: { overlay: State }) => state.overlay.tokenLoaded,
  (state: { overlay: State }) => state.overlay.accessChecked,
  (tokenLoaded, accessChecked) => tokenLoaded && accessChecked,
);

export default overlaySlice.reducer;
